import { Button, Select, Switch } from "antd";
import { FC } from "react";
import { useIntl } from "react-intl";

interface OnlineBookingSettingsProps {}

const OnlineBookingSettings: FC<OnlineBookingSettingsProps> = ({}) => {
  const intl = useIntl();
  const minBeforeReservationOptions = [
    {
      label: intl.formatMessage({ id: "2_hours_before_appointment" }),
      value: "2",
      key: "2",
    },
    {
      label: intl.formatMessage({ id: "4_hours_before_appointment" }),
      value: "4",
      key: "4",
    },
    {
      label: intl.formatMessage({ id: "6_hours_before_appointment" }),
      value: "6",
      key: "6",
    },
  ];
  const maxBeforeReservationOptions = [
    {
      label: intl.formatMessage({ id: "30_days_before_appointment" }),
      value: "30",
      key: "30",
    },

    {
      label: intl.formatMessage({ id: "10_days_before_appointment" }),
      value: "10",
      key: "10",
    },

    {
      label: intl.formatMessage({ id: "5_days_before_appointment" }),
      value: "5",
      key: "5",
    },

    {
      label: intl.formatMessage({ id: "20_days_before_appointment" }),
      value: "20",
      key: "20",
    },
  ];
  const minBeforeCancelReservationOptions = [
    {
      label: intl.formatMessage({ id: "4_days_before_appointment" }),
      value: "4",
      key: "4",
    },

    {
      label: intl.formatMessage({ id: "3_days_before_appointment" }),
      value: "3",
      key: "3",
    },

    {
      label: intl.formatMessage({ id: "7_days_before_appointment" }),
      value: "7",
      key: "7",
    },

    {
      label: intl.formatMessage({ id: "2_days_before_appointment" }),
      value: "2",
      key: "2",
    },
  ];
  return (
    <div className="py-12 px-8 bg-[#EEF0FF] space-y-8">
      <div className="space-y-3">
        <h2 className="text-2xl text-color-primary">
          {intl.formatMessage({ id: "online_account_settings" })}
        </h2>
        <p className="text-[#75757E]">
          {intl.formatMessage({ id: "online_account_settings_description" })}
        </p>
      </div>
      <div className="px-6 py-8 bg-white rounded shadow-full space-y-6">
        <div className="flex flex-col lg:flex-row gap-4 justify-between">
          <div>
            <h4 className="text-lg font-semibold">
              {intl.formatMessage({ id: "booking_time_settings" })}
            </h4>
            <p className="text-color-sec-title text-sm">
              {intl.formatMessage({ id: "booking_time_settings_description" })}
            </p>
          </div>
          <div className="flex flex-col lg:flex-row gap-4 justify-between">
            <div className="flex flex-col gap-2">
              <label htmlFor="minBeforeReservation">
                {intl.formatMessage({ id: "min_reservation_time" })}
              </label>
              <Select
                id="minBeforeReservation"
                className=""
                options={minBeforeReservationOptions}
                defaultValue={minBeforeReservationOptions[0].value}
              />
            </div>
            <div className="flex flex-col gap-2">
              <label htmlFor="maxBeforeReservation">
                {intl.formatMessage({ id: "max_reservation_time" })}
              </label>
              <Select
                id="maxBeforeReservation"
                className=""
                options={maxBeforeReservationOptions}
                defaultValue={maxBeforeReservationOptions[0].value}
              />
            </div>
          </div>
        </div>
        <hr />
        <div className="flex flex-col lg:flex-row gap-3 justify-between">
          <div>
            <h4 className="text-lg font-semibold">
              {intl.formatMessage({ id: "cancellation_policy" })}
            </h4>
            <p className="text-color-sec-title text-sm">
              {intl.formatMessage({ id: "cancellation_policy_description" })}
            </p>
          </div>
          <div className="flex flex-col lg:flex-row gap-4 justify-between">
            <div className="flex flex-col gap-2">
              <label htmlFor="minBeforeCancelReservation">
                {intl.formatMessage({ id: "min_cancelation_time" })}
              </label>
              <Select
                id="minBeforeCancelReservation"
                className=""
                options={minBeforeCancelReservationOptions}
                defaultValue={minBeforeCancelReservationOptions[0].value}
              />
            </div>
          </div>
        </div>
        <hr />
        <div className="flex flex-col lg:flex-row gap-4 justify-between">
          <div>
            <h4 className="text-lg font-semibold">
              {intl.formatMessage({ id: "multiple_services_booking" })}
            </h4>
            <p className="text-color-sec-title text-sm">
              {intl.formatMessage({
                id: "multiple_services_booking_description",
              })}
            </p>
          </div>
          <div className="">
            <Switch
              checkedChildren={intl.formatMessage({ id: "enabled" })}
              unCheckedChildren={intl.formatMessage({ id: "disabled" })}
            />
          </div>
        </div>
        <hr />
        <div className="flex flex-col lg:flex-row gap-4 justify-between">
          <div>
            <h4 className="text-lg font-semibold">
              {intl.formatMessage({ id: "customer_rating_availability" })}
            </h4>
            <p className="text-color-sec-title text-sm">
              {intl.formatMessage({
                id: "customer_rating_availability_description",
              })}
            </p>
          </div>
          <div className="">
            <Switch
              checkedChildren={intl.formatMessage({ id: "enabled" })}
              unCheckedChildren={intl.formatMessage({ id: "disabled" })}
            />
          </div>
        </div>
      </div>
      <div className="flex justify-center lg:justify-end ">
        <Button
          type="primary"
          htmlType="button"
          className="w-full  lg:w-[165px] m-1"
        >
          {intl.formatMessage({ id: "saveChanges" })}
        </Button>
        <Button
          type="default"
          htmlType="button"
          className="w-full lg:w-[165px] m-1"
        >
          {intl.formatMessage({ id: "cancel" })}
        </Button>
      </div>
    </div>
  );
};

export default OnlineBookingSettings;
